<form>
  <mat-dialog-content class="!grid">    
    <p class="dialog-title pt-0">Terminar Entregable</p>
    <hr class="dialog-divider" />
    <p class="dialog-subtitle">SELECCIONA ENTREGABLES A TERMINAR</p>
    <div class="">
      @for (entregable of entregables; track $index) {
      <div class="flex justify-between items-center">
        <p  class="grow !truncate !text-balance list-item">
          {{
            entregable.nombreEntregable
              ? entregable.nombreEntregable
              : "Adjuntar Archivo"
          }}
        </p>
        <mat-checkbox
          [color]="'primary'"
          [(ngModel)]="entregable.selected"
          (change)="updateSelectAllState()"
          name="entregables_{{ $index }}"
          class="example-margin"></mat-checkbox>
      </div>
      }
      <div class="flex justify-between items-center">
        <p class="select-all">Seleccionar todos</p>
        <mat-checkbox
          [color]="'warn'"
          name="selectAllChecked"
          [(ngModel)]="selectAllChecked"
          (change)="selectAll($event.checked)"
          class="example-margin"></mat-checkbox>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end">
    <button
      class="uppercase-button"
      mat-raised-button
      [mat-dialog-close]="false">
      CANCELAR
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="getEntregaablesChecked().length <= 0"
      (click)="save()">
      ACEPTAR
    </button>
  </mat-dialog-actions>
</form>
